// extracted by mini-css-extract-plugin
module.exports = {"post__description":"styles_post__description__cBK5M","post__description__desk":"styles_post__description__desk__mFmEt","markdown":"styles_markdown__H0DWG"};